import React from 'react';
import styles from './styles.module.scss';
import { ProductType } from '../../types';
import { trackCallButtonClick, trackAppDownloadClick } from '../../utils/tracking';

interface SuccessSlideProps {
  productType: ProductType;
  zipFlag: boolean | null;
  zipCode?: string;
  mongoId?: string;
  phone?: string;
  consumoAnnuo?: number | null;
}

/**
 * Slide di successo dopo l'invio del form
 */
const SuccessSlide: React.FC<SuccessSlideProps> = ({
  mongoId,
  phone,
}) => {

  const handleCallClick = () => {
    trackCallButtonClick();
  };

  const handleAppDownloadClick = () => {
    trackAppDownloadClick();
  };


  return (
    <div className={styles.successSlide}>
      <div className={styles.successHeader}>
        <div className={styles.successCheckmark}>✓</div>
      </div>

      <h3 className={styles.successMainTitle}>
        Ti chiameremo a breve da un numero di cellulare.
      </h3>

      <p className={styles.successSubtitle}>
        Alternativamente, puoi contattarci tu:
      </p>

      <div className={styles.successCtaBar}>
        <a
          href="tel:00393476331490"
          className={styles.btnCallNow}
          onClick={handleCallClick}
        >
          Chiamaci ora
        </a>
      </div>

      {mongoId && (
        <a
          href={`https://app.enpal.it/login?payload=${btoa(phone || '')}`}
          className={styles.appCta}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleAppDownloadClick}
        >
          Scarica l&apos;app per scoprire di più sui bonus
        </a>
      )}
    </div>
  );
};

export default SuccessSlide;
